module.exports = __webpack_public_path__ + "0358e5cbf1a07b1fd5025d7324e26a05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room9/4th-FLOOR_VIEW-6_SCALE-A_square.jpg
// module id = 232
// module chunks = 0